import localConfig from './local';
import devConfig from './dev';

export default new Map([
  ['local', localConfig],
  ['dev', devConfig]
]);
